export type TNativeAudioBuffer = AudioBuffer;
